<template lang="pug">
v-card.pa-6.mb-6.rounded-lg(outlined)
  .text-md.font-semibold.neutral700--text.mb-4 Delivery details
  v-row(no-gutters)
    v-col.pr-5(cols="4")
      .text-sm.font-semibold.neutral700--text Preferred delivery date (optional)
      div.mt-2(v-if="isLocked")
        span(v-if="preferredDeliveryDate") {{ preferredDeliveryDate | humanizeDate }}
        span(v-else) -
      date-picker.mt-2(v-else v-model="preferredDeliveryDate" title="Select preferred delivery date" :height="36")
    v-col.pr-5(cols="4")
      //- TODO: replace with API-backed searchable dropdown with create-new capability once API ready
      .text-sm.font-semibold.neutral700--text Preferred delivery method
      div.mt-2(v-if="isLocked") {{ deliveryMethodDisplayText }}
      yz-dropdown.mt-2(v-else v-model="preferredDeliveryMethod" :items="deliveryMethodItems" placeholder="Select delivery method")
    v-col(cols="4")
      .text-sm.font-semibold.neutral700--text Priority
      div.mt-2(v-if="isLocked") {{ priorityDisplayText }}
      yz-dropdown.mt-2(v-else v-model="priority" :items="priorityItems" placeholder="Select priority")
</template>

<script>
import DatePicker from '@/components/clinic/custom/DatePicker.vue'

export default {
  components: { DatePicker },
  props: {
    selectedDocument: {
      type: Object,
      required: true
    },
    parentData: {
      type: Object,
      default: null
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    this.populateFromParentData()
  },
  data () {
    return {
      preferredDeliveryDate: null,
      preferredDeliveryMethod: null,
      priority: null,
      // TODO: replace with API-fetched delivery methods once API ready
      deliveryMethodItems: [
        { text: 'Standard shipping', value: 'standard_shipping' },
        { text: 'Express shipping', value: 'express_shipping' },
        { text: 'Same day delivery', value: 'same_day_delivery' },
        { text: 'Pickup', value: 'pickup' },
      ],
      priorityItems: [
        { text: 'Standard', value: 'standard' },
        { text: 'Urgent', value: 'urgent' },
      ],
    }
  },
  watch: {
    parentData: {
      immediate: true,
      handler () {
        this.populateFromParentData()
      },
    },
    preferredDeliveryDate () {
      this.emitInput()
    },
    preferredDeliveryMethod () {
      this.emitInput()
    },
    priority () {
      this.emitInput()
    },
  },
  methods: {
    emitInput () {
      this.$emit('input', {
        preferredDeliveryDate: this.preferredDeliveryDate,
        preferredDeliveryMethod: this.preferredDeliveryMethod,
        priority: this.priority,
      })
    },
    populateFromParentData () {
      const details = this.parentData?.delivery_details
      if (!details) return
      this.preferredDeliveryDate = details.preferred_delivery_date || null
      this.preferredDeliveryMethod = details.preferred_delivery_method || null
      this.priority = details.priority || null
      this.$nextTick(() => this.emitInput())
    },
  },
  computed: {
    status () {
      return this.parentData?.request_status || this.parentData?.order_status
    },
    isArchived () {
      return this.status === 'archived'
    },
    isCompleted () {
      return this.status === 'completed'
    },
    isCreated () {
      return this.status === 'created'
    },
    isLocked () {
      if (this.isArchived || this.isCompleted || this.isCreated) return true
      if (this.selectedDocument.id === 'stock-transfer' && ['requested', 'rejected'].includes(this.status)) return true
      return false
    },
    priorityDisplayText () {
      if (!this.priority) return '-'
      const item = this.priorityItems.find(i => i.value === this.priority)
      return item ? item.text : this.priority
    },
    deliveryMethodDisplayText () {
      if (!this.preferredDeliveryMethod) return '-'
      const item = this.deliveryMethodItems.find(i => i.value === this.preferredDeliveryMethod)
      return item ? item.text : this.preferredDeliveryMethod
    },
  },
}
</script>
